import { useEffect, useState } from "react";
import { getPublicBranding } from "@/lib/api";

export function useTenantBranding(query) {
  const [brand, setBrand] = useState(null);
  const key = JSON.stringify(query);
  useEffect(() => {
    let cancelled = false;
    getPublicBranding(JSON.parse(key)).then((b) => { if (!cancelled) setBrand(b); });
    return () => { cancelled = true; };
  }, [key]);
  return brand;
}

export const TenantLogo = ({ brand, className = "" }) => {
  if (!brand?.logo_url) return null;
  return (
    <div className={`flex items-center ${className}`} data-testid="public-tenant-brand">
      <img
        src={brand.logo_url}
        alt={`${brand.name} logo`}
        className="h-10 sm:h-12 w-auto max-w-[220px] object-contain"
        data-testid="public-tenant-logo"
      />
    </div>
  );
};
